import { call, put } from 'redux-saga/effects';
import { onboardingService } from '../services/onboardingService';
import { onboardingConstants } from '../actions/constants/onboardingConstants';
import { commonConstants } from '@/actions/constants/commonConstants';

function* inviteUser(action: any): any {
  try {
    const response = yield call(onboardingService.inviteUser, action.payload);
    if (response && response.success){
      yield put({ type: onboardingConstants.inviteUserSuccess, payload: response.resultObject});
      yield put({type: commonConstants.showSuccessMessage, payload:response.message})
    }else{
      yield put({ type: onboardingConstants.inviteUserFailure, payload: response.errorMessage || response });
      yield put({type: commonConstants.showErrorMessage, payload:response.errorMessage})
    }
  } catch (error) {
    yield put({ type: onboardingConstants.inviteUserFailure, payload: error });
    yield put({type: commonConstants.showErrorMessage, payload:error})
  }
}

function* signup(action: any): any {
  try {
    const { onSuccess, onError, ...payload } = action.payload;
    const response = yield call(onboardingService.signup, payload);
    if (response && response.success) {
      yield put({ type: onboardingConstants.signupSuccess, payload: response.resultObject || response });
      yield put({type: commonConstants.showSuccessMessage, payload:response.message})
      if (onSuccess && typeof onSuccess === 'function') {
        onSuccess(response.resultObject || response);
      }
      
    } else {
      const errorMsg = response.errorMessage || 'Signup failed';
      yield put({ type: onboardingConstants.signupFailure, payload: errorMsg });
      yield put({type: commonConstants.showErrorMessage, payload:errorMsg})
      if (onError && typeof onError === 'function') {
        onError(errorMsg);
      }
    }
  } catch (error: any) {
    const errorMsg = error.message || 'An error occurred';
    yield put({ type: onboardingConstants.signupFailure, payload: errorMsg });
    if (action.payload.onError && typeof action.payload.onError === 'function') {
      action.payload.onError(errorMsg);
    }
  }
}

function* verifyKyc(action: any): any {
  try {
    const { onSuccess, onError, ...payload } = action.payload;
    const response = yield call(onboardingService.verifyKyc, payload);

    if (response && response.success) {
      yield put({ type: onboardingConstants.verifyKycSuccess, payload: response.resultObject || response });
      if (onSuccess && typeof onSuccess === 'function') {
        onSuccess(response.resultObject || response);
      }
    } else {
      const errorMsg = response?.errorMessage || 'KYC verification failed';
      yield put({ type: onboardingConstants.verifyKycFailure, payload: errorMsg });
      if (onError && typeof onError === 'function') {
        onError(errorMsg);
      }
    }
  } catch (error: any) {
    const errorMsg = error?.message || 'KYC verification failed';
    yield put({ type: onboardingConstants.verifyKycFailure, payload: errorMsg });
    if (action.payload.onError && typeof action.payload.onError === 'function') {
      action.payload.onError(errorMsg);
    }
  }
}

function* referralDecision(action: any): any {
  try {
    const response = yield call(onboardingService.referralDecision, action.payload);
    if (response && response.success)
      yield put({ type: onboardingConstants.referralDecisionSuccess, payload: response.resultObject || response });
    else
      yield put({ type: onboardingConstants.referralDecisionFailure, payload: response.errorMessage || response });
  } catch (error) {
    yield put({ type: onboardingConstants.referralDecisionFailure, payload: error });
  }
}

function* fetchReferrals(action: any): any {
  try {
    const response = yield call(onboardingService.fetchReferrals, action.payload);

    if (response && response.success)
      yield put({ type: onboardingConstants.fetchReferralsSuccess, payload: response.resultObject });
    else
      yield put({ type: onboardingConstants.fetchReferralsFailure, payload: response.errorMessage || response });
  } catch (error) {
    yield put({ type: onboardingConstants.fetchReferralsFailure, payload: error });
  }
}

function* fetchUserDetails(action: any): any {
  try {
    const response = yield call(onboardingService.fetchUserDetails, action.payload);
    if (response && response.success)
      yield put({ type: onboardingConstants.fetchUserDetailsSuccess, payload: response.data || response });
    else
      yield put({ type: onboardingConstants.fetchUserDetailsFailure, payload: response.errorMessage || response });
  } catch (error) {
    yield put({ type: onboardingConstants.fetchUserDetailsFailure, payload: error });
  }
}

function* processDecision(action: any): any {
  try {
    const response = yield call(onboardingService.processDecision, action.payload);
    if (response && response.success)
      yield put({ type: onboardingConstants.processDecisionSuccess, payload: response.resultObject || response });
    else
      yield put({ type: onboardingConstants.processDecisionFailure, payload: response.errorMessage || response });
  } catch (error) {
    yield put({ type: onboardingConstants.processDecisionFailure, payload: error });
  }
}

function* fetchDraft(action: any): any {
  try {
    const { tempId, role, type, isInvite, onSuccess, onError } = action.payload;
    const response = yield call(onboardingService.fetchDraft, tempId, role, type, isInvite);
    if (response && response.success) {
      yield put({ type: onboardingConstants.fetchDraftSuccess, payload: response.resultObject || response });
      yield put({type:commonConstants.showSuccessMessage, payload:response.message})
      if (onSuccess && typeof onSuccess === 'function') {
        onSuccess(response.resultObject || response);
      }
    } else {
      const errorMsg = response.errorMessage || 'Failed to fetch draft';
      yield put({ type: onboardingConstants.fetchDraftFailure, payload: errorMsg });
      if (onError && typeof onError === 'function') {
        onError(errorMsg);
      }
    }
  } catch (error: any) {
    const errorMsg = error.message || 'An error occurred while fetching draft';
    yield put({ type: onboardingConstants.fetchDraftFailure, payload: errorMsg });
    if (action.payload.onError && typeof action.payload.onError === 'function') {
      action.payload.onError(errorMsg);
    }
  }
}

export const onboardingSaga = {
  inviteUser,
  signup,
  verifyKyc,
  referralDecision,
  fetchReferrals,
  fetchUserDetails,
  processDecision,
  fetchDraft,
};
